import { render, staticRenderFns } from "./stream-announcement.vue?vue&type=template&id=dc32157a&scoped=true&lang=pug&"
import script from "./stream-announcement.vue?vue&type=script&lang=js&"
export * from "./stream-announcement.vue?vue&type=script&lang=js&"
import style0 from "./stream-announcement.vue?vue&type=style&index=0&id=dc32157a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc32157a",
  null
  
)

export default component.exports